export const selectOrganization = (organization) => ({
    type: 'SELECT_ORGANIZATION_SET',
    payload: organization
});

export const showOrganization = () => ({
    type: 'SELECT_ORGANIZATION_SHOW'
});